import script from "./MobileViewerHint.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileViewerHint.vue?vue&type=script&setup=true&lang=js"

import "./MobileViewerHint.vue?vue&type=style&index=0&id=038f7cb7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-038f7cb7"]])

export default __exports__